import { TableRow, TableHead, TableCell } from '@material-ui/core';
import React from 'react';

import { styles } from './Table';

const TableHeader = ({ headers, buttonTitle }) => {
  return (
    <TableHead>
      <TableRow>
        {headers?.map(({ title, key, width }) => (
            <TableCell style={styles.cell} width={width} padding="dense" key={key}>
              {title}
            </TableCell>
          ))}
        {buttonTitle && (
          <TableCell>
            <p>{buttonTitle}</p>
          </TableCell>
        )}
      </TableRow>
    </TableHead>
  );
};

export default TableHeader;
